'use strict';

export default class VZCard extends HTMLElement {
    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['visible'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'visible' && newValue === 'true') {
            this.classList.add('d-block');
            this.classList.remove('d-none');
        }
        if (name === 'visible' && newValue === 'false') {
            this.classList.add('d-none');
            this.classList.remove('d-block');
        }
    }
}

if (!window.customElements.get('vz-card')) {
    window.customElements.define('vz-card', VZCard);
}
